/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import error from '@pages/EventTrackerPage/config/error.config.json';
import loading from '@pages/EventTrackerPage/config/loading.config.json';
import notification from '@pages/EventTrackerPage/config/notifications.config.json';
import header from '@pages/EventTrackerPage/config/header.config.json';

export interface IStaticContentPluginMethods extends IPluginMethodMap {
  getStaticContentSync(args?: any): any;
}

export class StaticContentPlugin implements IAgentPlugin {
  readonly methods: IStaticContentPluginMethods;

  constructor() {
    this.methods = {
      getStaticContentSync: this.getStaticContentSync.bind(this),
    };
  }

  getStaticContentSync(args?: any) {
    return {
      loading: loading,
      error: error,
      notification: notification,
      header: header,
    };
  }
}
